import { AbortControllerManager } from '../abortControllerManager';
import { authClient, kioskClient, publicClient } from '../client';
import {
  TListCountriesResponse,
  TListLocationResponse,
  TListTimezonesResponse,
  TLocationParams,
} from '@/types/list';

class ListApi extends AbortControllerManager {
  private LIST_URL = '/v2/lists';
  constructor() {
    super();
  }

  // Without token
  getListCountries(): Promise<TListCountriesResponse> {
    const url = `${this.LIST_URL}/countries`;
    const signal = this.createAbortController('getListCountries');
    return publicClient.get(url, { signal });
  }

  getListTimezones(): Promise<TListTimezonesResponse> {
    const url = `${this.LIST_URL}/timezones`;
    const signal = this.createAbortController('getListTimezones');
    return authClient.get(url, { signal });
  }

  getListTimezonesByKiosk(): Promise<TListTimezonesResponse> {
    const url = `${this.LIST_URL}/timezones`;
    const signal = this.createAbortController('getListTimezonesByKiosk');
    return kioskClient.get(url, { signal });
  }

  getLocation(params: TLocationParams): Promise<TListLocationResponse> {
    const url = `${this.LIST_URL}/location`;
    const signal = this.createAbortController('getLocation');
    return authClient.get(url, { params, signal });
  }

  getLocationByKiosk(params: TLocationParams): Promise<TListLocationResponse> {
    const url = `${this.LIST_URL}/location`;
    const signal = this.createAbortController('getLocationByKiosk');
    return kioskClient.get(url, { params, signal });
  }
}

export const listApi = new ListApi();
